'use strict';
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_ResolverStyle() {
  this.q = null;
  this.M = 0;
}
export { $c_Ljava_time_format_ResolverStyle as $c_Ljava_time_format_ResolverStyle };
$p = $c_Ljava_time_format_ResolverStyle.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_Ljava_time_format_ResolverStyle;
/** @constructor */
function $h_Ljava_time_format_ResolverStyle() {
}
export { $h_Ljava_time_format_ResolverStyle as $h_Ljava_time_format_ResolverStyle };
$h_Ljava_time_format_ResolverStyle.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
